class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer =
      this.querySelector('details');

    this.summaryToggle =
      this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) =>
        event.code.toUpperCase() === 'ESCAPE' &&
        this.close()
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.querySelector('button[type="button"]')
      .addEventListener(
        'click',
        this.close.bind(this)
      );

    this.summaryToggle.setAttribute(
      'role',
      'button'
    );
  }


  isOpen() {
    return this.detailsContainer.hasAttribute(
      'open'
    );
  }


  onSummaryClick(event) {
    event.preventDefault();

    this.isOpen()
      ? this.close()
      : this.open(event);
  }


  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains(
        'modal-overlay'
      )
    ) {
      this.close(false);
    }
  }


  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent ||
      this.onBodyClick.bind(this);

    const details =
      event.target.closest('details');

    details.classList.remove(
      'aurora-search-closing'
    );

    details.classList.remove(
      'aurora-search-visible'
    );

    details.setAttribute(
      'open',
      ''
    );

    document.body.addEventListener(
      'click',
      this.onBodyClickEvent
    );

    document.body.classList.add(
      'overflow-hidden'
    );


    /*
     * Primero Safari dibuja el drawer
     * fuera de pantalla.
     *
     * Después activamos la transición.
     * Evita el doble salto en iPhone.
     */
    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        details.classList.add(
          'aurora-search-visible'
        );

      });

    });


    const focusContainer =
  this.detailsContainer.querySelector(
    '[tabindex="-1"]'
  );

const searchInput =
  this.detailsContainer.querySelector(
    'input:not([type="hidden"])'
  );

const isMobile =
  window.matchMedia(
    '(max-width: 749px)'
  ).matches;


/*
 * En móvil NO enfocamos automáticamente
 * el input.
 *
 * Safari puede mover el documento al
 * intentar abrir inmediatamente el teclado.
 */
trapFocus(
  focusContainer,
  isMobile
    ? focusContainer
    : searchInput
);
  }


  close(focusToggle = true) {
    if (!this.isOpen()) return;

    if (
      this.detailsContainer.classList.contains(
        'aurora-search-closing'
      )
    ) {
      return;
    }


    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    const modal =
      this.detailsContainer.querySelector(
        '.search-modal'
      );


    let finished = false;


    const finishClose = () => {

      if (finished) return;

      finished = true;


      modal?.removeEventListener(
        'transitionend',
        onTransitionEnd
      );


      removeTrapFocus(
        focusToggle
          ? this.summaryToggle
          : null
      );


      this.detailsContainer.removeAttribute(
        'open'
      );


      this.detailsContainer.classList.remove(
        'aurora-search-visible',
        'aurora-search-closing'
      );


      document.body.removeEventListener(
        'click',
        this.onBodyClickEvent
      );


      document.body.classList.remove(
        'overflow-hidden'
      );
    };


    const onTransitionEnd = (event) => {

      if (
        event.target === modal &&
        event.propertyName === 'transform'
      ) {
        finishClose();
      }

    };


    if (reducedMotion || !modal) {

      finishClose();

      return;

    }


    this.detailsContainer.classList.add(
      'aurora-search-closing'
    );


    this.detailsContainer.classList.remove(
      'aurora-search-visible'
    );


    modal.addEventListener(
      'transitionend',
      onTransitionEnd
    );


    /*
     * Seguridad:
     * por si Safari no dispara transitionend.
     */
    window.setTimeout(
      finishClose,
      500
    );
  }
}


customElements.define(
  'details-modal',
  DetailsModal
);
